import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-buttons-layout',
    template: `
    <div class="d-flex bd-highlight px-2"> 
        <ng-content></ng-content>
    </div>
  `,
    standalone: false
})
export class ButtonsLayoutComponent {
  @Input() isModal = false;
}

